import IM from './im'
import cloneDeep from "lodash/cloneDeep"
import { createTeam, groupAddMember, groupRemoveMember, quitGroup, dissolutionGroup } from '@/im/api'

export default {
  state: {
    teamsList: [],
  },
  mutations: {
    SET_TEAMSLIST(state, list) {
      state.teamsList = list
    },
  },
  actions: {
    teamsUpdate({ state, commit, getters, dispatch }, data) {
      const teamsMap = {}
      let arr = cloneDeep(state.teamsList)
      arr.forEach(i => {
        if (i.tid) teamsMap[i.tid] = i
      })
      if (Array.isArray(data)) {
        data.forEach(i => {
          if (i.tid && teamsMap[i.tid]) {
            let ind = arr.findIndex(item => item.tid === i.tid);
            if (ind === -1) {
              arr.push({ ...(teamsMap[i.tid] || {}), ...i })
            } else {
              arr.splice(ind, 1, { ...arr[i], ...i })
            }
            teamsMap[i.tid] = { ...(teamsMap[i.tid] || {}), ...i }
          } else if (i.tid && !teamsMap[i.tid]) {
            arr.push(i)
            teamsMap[i.tid] = { ...(teamsMap[i.tid] || {}), ...i }
          }
        })
      } else {
        let ind = arr.findIndex(i => i.tid === data.tid);
        if (ind === -1) {
          arr.push(data)
        } else {
          arr.splice(ind, 1, { ...arr[ind], ...data })
        }
      }
      if (state.currentSession) {
        if (!getters.singleMap[state.currentSession] && !arr.find(i => i.tid === state.currentSession)) {
          dispatch('setCurrentSession')
        }
      }
      commit('SET_TEAMSLIST', arr)
    },
    dismissTeam({ state, commit, dispatch }, tid) {
      let arr = cloneDeep(state.teamsList)
      let ind = arr.findIndex(i => i.tid === tid)
      if (ind !== -1) arr.splice(ind, 1)
      if (state.currentSession && state.currentSession === tid) dispatch('setCurrentSession');
      commit('SET_TEAMSLIST', arr)
    },
    async getTeamDetail(_, tid) {
      IM.getInstance().getTeamDetail(tid)
    },
    createTeam(_, info) {
      return createTeam(info)
    },
    teamAddMember({ state }, list) {
      return groupAddMember(list, { tid: state.currentSession })
    },
    teamRemoveMember({ state }, list) {
      return groupRemoveMember(list, { tid: state.currentSession })
    },
    quitTeam({ state }) {
      return quitGroup({ tid: state.currentSession })
    },
    dissolutionTeam({ state }) {
      return dissolutionGroup({ tid: state.currentSession })
    },
  },
  getters: {
    teamsMap(state) {
      const teamsMap = {}
      state.teamsList.forEach(i => {
        if (i.tid) teamsMap[i.tid] = i
      })
      return teamsMap
    },
    currentTeamUsersMap(state) {
      if (!state.currentSession) return {}
      const teamsMap = {},
        membersMap = {};
      state.teamsList.forEach(i => {
        if (i.tid) teamsMap[i.tid] = i
      })
      if (!teamsMap[state.currentSession]) return {}
      if (!teamsMap[state.currentSession].teamMembers) return {}
      teamsMap[state.currentSession].teamMembers.forEach(i => {
        if (i.accid || i.accId) membersMap[i.accid || i.accId] = i
      })
      return membersMap || {}
    },
  }
}
